import {gql} from "apollo-angular";
import {baseResponseGraphqlField} from "../../../store/base.graphql";

export const CITIZEN_VERIFY_OTP_NUMBER = gql`
  mutation CitizenVerifyOtpNumber($email: String, $phoneNumber: String, $password: String!)  {
    citizenVerifyOtpNumber(email: $email, phoneNumber: $phoneNumber, password: $password) {
      ${baseResponseGraphqlField}
    }
  }`
